import { Injectable, inject } from "@angular/core";
import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { ResponseContainer } from "../../interfaces/response-container.interface";

@Injectable({
  providedIn: "root",
})
export class WarmUpService {
  private baseApiService = inject(BaseApiService);
  private http = inject(HttpClient);

  wakeUpBackOfficeFunctions(): boolean {
    this.http
      .get<ResponseContainer<boolean>>(`${this.baseApiService.rootUrl}/warm-up/backoffice`)
      .subscribe();
    return true;
  }
}
